module.exports = __webpack_public_path__ + "img/textarea.6a19873e.svg";